import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Item 91: ARIA live region that announces page changes to screen readers.
 * Visually hidden, announces the document title on route change.
 */
export default function RouteAnnouncer() {
  const location = useLocation();
  const [announcement, setAnnouncement] = useState('');

  useEffect(() => {
    // Small delay to let usePageMeta update document.title first
    const timer = setTimeout(() => {
      setAnnouncement(document.title || 'Page loaded');
    }, 100);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  return (
    <div
      role="status"
      aria-live="polite"
      aria-atomic="true"
      className="sr-only"
    >
      {announcement}
    </div>
  );
}
